import React from "react";
import { styled } from "styled-components";
import LogoRound from "../Svg/Icons/LogoRound";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
import { Colors } from "../../theme";

export interface Props {
  color?: keyof Colors;
  plsxPriceUsd?: number;
  showSkeleton?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  pointer-events: none;
`;

const PlsxPrice: React.FC<React.PropsWithChildren<Props>> = ({
  plsxPriceUsd,
  color = "textSubtle",
  showSkeleton = true,
}) => {
  return plsxPriceUsd ? (
    <Wrapper>
      <LogoRound width="24px" mr="8px" />
      <Text color={color} bold>{`$${plsxPriceUsd.toFixed(7)}`}</Text>
    </Wrapper>
  ) : showSkeleton ? (
    <Skeleton width={80} height={24} />
  ) : null;
};

export default React.memo(PlsxPrice);
